export default __webpack_public_path__ + "static/logo-header-5d2d89b19dc7fb264a5600823989e7d7.png";